import React from 'react';
import SegmentedControl from '../../../../../components/SegmentedControl';
import {FileCard} from './FileCard';
import {Pagination} from './Pagination';

/**
 * Files grid display component
 */
export const FilesGrid = ({
  filtered,
  showUpload,
  scope,
  setScope,
  scopeCounts,
  resourceName,
  filesPage,
  setFilesPage,
  filesPerPage,
  setFilesPerPage,
  onDownload,
  onEdit,
  onDelete
}) => {
  const scopeOptions = [
    {value: 'resource', label: 'Resource', count: scopeCounts?.resource},
    {value: 'all', label: 'Platform', count: scopeCounts?.all},
  ];

  // When viewing resource files without a resource selected in the header,
  // guide the user instead of showing a bare "No files found".
  const emptyMessage = scope === 'resource' && !resourceName
    ? 'Select a resource from the header to view its files'
    : 'No files found';

  return (
    <div className="rounded-lg bg-surface dark:bg-gray-870 p-4 sm:p-6 shadow-sm border border-gray-200/70 dark:border-gray-600/70 flex flex-col">
      {/* Header: title left, scope switcher right (mirrors the Exports card below) */}
      <div className="mb-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
        <div>
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Files</h2>
          <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400 mt-1">
            {showUpload ? 'Browse and manage uploaded files' : 'Browse and download available files'}
          </p>
        </div>
        <div className="shrink-0">
          <SegmentedControl
            options={scopeOptions}
            value={scope}
            onChange={setScope}
            ariaLabel="File scope"
            size="lg"
          />
        </div>
      </div>

      <div className="flex flex-col flex-1">
        {filtered.length === 0 ? (
          <div className="py-6 text-center text-sm text-gray-500">{emptyMessage}</div>
        ) : (
          <>
            <div className="space-y-2 flex-1">
              {filtered
                .slice((filesPage - 1) * filesPerPage, filesPage * filesPerPage)
                .map(item => (
                  <FileCard
                    key={item.id}
                    file={item}
                    showUpload={showUpload}
                    onDownload={onDownload}
                    onEdit={onEdit}
                    onDelete={onDelete}
                  />
                ))}
            </div>

            {filtered.length > 0 && (
              <Pagination
                currentPage={filesPage}
                totalItems={filtered.length}
                itemsPerPage={filesPerPage}
                onPageChange={setFilesPage}
                onItemsPerPageChange={(value) => {
                  setFilesPerPage(value);
                  setFilesPage(1);
                }}
                itemsPerPageOptions={[3, 6, 12, 24]}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};
